import type { GetBusinessInfoResponse } from 'bookings-shared/lib/c2/services/schema/getBusinessInfo';
import type { BusinessInfo } from '../../store/schema/BusinessInfo';
import type { Settings, ThemeData } from '../../store/schema/Settings';

export const mapBusinessInfoResponse = (response: GetBusinessInfoResponse): BusinessInfo => {
    return {
        Name: response.businessInfo.displayName,
    };
};

export const settingsMapper = (response: GetBusinessInfoResponse): Settings => {
    const settings = response.businessInfo.settings;
    return {
        PublishingUrl: settings.publishingUrl,
        ServiceRequestUrl: settings.serviceRequestUrl,
        ThemeData: mapThemeData(response),
        IsLogoHidden: settings.isLogoHidden,
        IsConsentNeeded: settings.isConsentNeeded,
        ConsentText: settings.consentText,
        CustomColorScheme: settings.customColorScheme,
        AuthType: settings.authType,
        IsNewC2RevampedEnabled: settings.c2RevampedEnabled,
    };
};

const mapThemeData = (response: GetBusinessInfoResponse): ThemeData => {
    return {
        PaletteId: response.businessInfo.settings.themeData.paletteId,
        PatternId: response.businessInfo.settings.themeData.patternId,
        PictureId: response.businessInfo.settings.themeData.pictureId,
    };
};
